
import { smartDeployBrand } from './brand';

const brand = smartDeployBrand.colors;

export const getDesignTokens = (mode) => ({
    palette: {
        mode,
        ...(mode === 'dark'
            ? {
                primary: {
                    main: brand.brightBlue,
                    light: brand.brightBlueLight,
                    dark: brand.brightBlueDark,
                },
                secondary: {
                    main: brand.steelGray,
                    light: brand.lightGray,
                    dark: '#334155',
                },
                background: {
                    default: brand.deepNavyDark,
                    paper: brand.deepNavy,
                },
                text: {
                    primary: brand.lightGray,
                    secondary: '#B5C0CC',
                },
                divider: 'rgba(255, 255, 255, 0.08)',
                action: {
                    hover: 'rgba(255, 255, 255, 0.05)',
                    selected: 'rgba(30, 136, 255, 0.12)',
                },
            }
            : {
                primary: {
                    main: brand.brightBlue,
                    light: brand.brightBlueLight,
                    dark: brand.brightBlueDark,
                },
                secondary: {
                    main: brand.steelGray,
                    light: brand.lightGray,
                    dark: '#334155',
                },
                background: {
                    default: '#F7F9FC',
                    paper: brand.white,
                },
                text: {
                    primary: brand.deepNavy,
                    secondary: brand.steelGray,
                },
                divider: 'rgba(0, 0, 0, 0.08)',
                action: {
                    hover: 'rgba(0, 0, 0, 0.04)',
                    selected: 'rgba(30, 136, 255, 0.08)',
                },
            }),
    },
    sidebar: {
        width: 220,
        collapsedWidth: 64,
        background: brand.deepNavy,
        text: '#C8D2DE',
        activeText: brand.white,
        activeBackground: 'rgba(30, 136, 255, 0.16)',
        hoverBackground: 'rgba(255, 255, 255, 0.06)',
        divider: 'rgba(255, 255, 255, 0.08)',
    },
    shape: {
        borderRadius: 6,
    },
    typography: {
        fontFamily: [
            'Inter',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
        ].join(','),
        h4: {
            fontWeight: 600,
            letterSpacing: 0,
        },
        h6: {
            fontWeight: 500,
        },
        button: {
            fontWeight: 500,
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: mode === 'dark' ? brand.deepNavyDark : '#F7F9FC',
                    scrollbarColor: mode === 'dark' ? `${brand.steelGray} ${brand.deepNavyDark}` : `${brand.steelGray} #F7F9FC`,
                    "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
                        backgroundColor: mode === 'dark' ? brand.deepNavyDark : '#F7F9FC',
                        width: "8px",
                    },
                    "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
                        borderRadius: 8,
                        backgroundColor: mode === 'dark' ? brand.steelGray : '#C7D0DA',
                        minHeight: 24,
                        border: mode === 'dark' ? `2px solid ${brand.deepNavyDark}` : "2px solid #F7F9FC",
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: 6,
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                    },
                },
                containedPrimary: {
                    background: mode === 'dark'
                        ? `linear-gradient(45deg, ${brand.brightBlue} 30%, ${brand.brightBlueLight} 90%)`
                        : `linear-gradient(45deg, ${brand.brightBlueDark} 0%, ${brand.brightBlue} 90%)`,
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    backgroundColor: mode === 'dark' ? brand.deepNavy : brand.white,
                    border: mode === 'dark'
                        ? '1px solid rgba(255, 255, 255, 0.05)'
                        : '1px solid rgba(0, 0, 0, 0.05)',
                    boxShadow: mode === 'dark'
                        ? '0 4px 6px -1px rgba(0, 0, 0, 0.2), 0 2px 4px -1px rgba(0, 0, 0, 0.1)'
                        : '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)',
                    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                },
            },
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    overflowX: 'auto',
                    maxHeight: '70vh',
                    '&::-webkit-scrollbar': {
                        height: 8,
                        width: 8,
                    },
                    '&::-webkit-scrollbar-thumb': {
                        borderRadius: 8,
                        backgroundColor: mode === 'dark' ? brand.steelGray : '#C7D0DA',
                    },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.15)',
                        },
                        '&:hover fieldset': {
                            borderColor: brand.brightBlue,
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: brand.brightBlue,
                        },
                    },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    fontWeight: 500,
                },
            },
        },
    },
});
